/**
 * Reports Constants
 * Constants and utility functions for reports endpoints
 */

/**
 * Build where clause for reports endpoints
 * @param {Object} selectedBrand - Selected brand object with id property
 * @returns {Object} Where clause object with conditions array
 */
export const buildReportsWhereClause = (selectedBrand) => {
  const baseWhere = {
    conditions: [],
    conector: "AND",
  };

  // Add business_id filter if brand is selected
  if (selectedBrand?.id) {
    baseWhere.conditions.push({
      attribute: "business_id",
      value: selectedBrand.id,
    });
  }

  return baseWhere;
};

/**
 * Build where clause for customer satisfaction reports
 * @param {Object} selectedBrand - Selected brand object with id property
 * @returns {Object} Where clause object with conditions array
 */
export const buildSatisfactionWhereClause = (selectedBrand) => {
  return buildReportsWhereClause(selectedBrand);
};

export default {
  buildReportsWhereClause,
  buildSatisfactionWhereClause,
};
